import React, { useState, useEffect } from "react";
import { fetchPacientes } from "../services/firebase/pacientes";
import { useSelector } from "react-redux";

export const useBuscarPacientes = () => {
  const [query, setQuery] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const empresa = useSelector((state) => state.empresa);

  useEffect(() => {
    if (!empresa?.id || query.length < 3) {
      setFilteredItems([]);
      setLoading(false); // Asegura que loading también se limpie
      return;
    }

    let isActive = true;
    const handler = setTimeout(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
          const data = await fetchPacientes(empresa.id, query);
          if (isActive) {
            setFilteredItems(data);
          }
        } catch (error) {
          if (isActive) {
            setFilteredItems([]);
          }
          console.error("Error fetching data:", error);
        }
        if (isActive) {
          setLoading(false);
        }
      };
      fetchData();
    }, 400);

    return () => {
      isActive = false;
      clearTimeout(handler);
    };
  }, [empresa?.id, query]);

  const clearFilteredItems = () => {
    setFilteredItems([]);
  };

  return { query, setQuery, filteredItems, clearFilteredItems, loading };
};
